import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { sendPasswordResetEmail } from 'firebase/auth';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (window.history.length <= 1) {
      navigate('/', { replace: true });
    } else {
      navigate(-1);
    }
  };

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape') handleGoBack();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError('');
    setMessage('');

    if (!email) {
      setError('Please enter a valid email address.');
      return;
    }

    setIsLoading(true);

    try {
      await sendPasswordResetEmail(auth, email);
      setMessage('If you are properly registered, you will receive a password reset link shortly.');
    } catch (err) {
      console.error('Error resetting password:', err);
      if (err.code === 'auth/invalid-email') {
        setError('Invalid email address.');
      } else if (err.code === 'auth/user-not-found') {
        setError('No user found with this email address.');
      } else {
        setError('An error occurred. Please try again later.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{
      position: 'relative',
      minHeight: '100vh',
      padding: '2rem',
      background: 'linear-gradient(to bottom, #1e293b, #0f172a)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white'
    }}>
      {/* Freccia indietro in alto a sinistra */}
      <button
        onClick={handleGoBack}
        aria-label="Torna alla pagina precedente"
        title="Torna indietro"
        style={{
          position: 'fixed',
          top: '1rem',
          left: '1rem',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '0.5rem',
          padding: '0.5rem 0.75rem',
          background: 'rgba(15, 23, 42, 0.7)',
          border: '1px solid #334155',
          color: 'white',
          borderRadius: '0.5rem',
          cursor: 'pointer',
          backdropFilter: 'blur(4px)',
          zIndex: 1000
        }}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        Back
      </button>

      <div style={{
        color: 'white', 
        padding: '2rem', 
        width: '100%',
        maxWidth: '400px', 
        background: '#1e293b', 
        borderRadius: '0.5rem', 
        border: '1px solid #334155',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      }}>
        <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', textAlign: 'center' }}>
          Reset Your Password
        </h2>
        <p style={{ textAlign: 'center', fontSize: '1rem', marginBottom: '1.5rem', color: '#cbd5e1' }}>
          Please enter your email address. We will send you a link to reset your password.
        </p>

        {/* Error */}
        {error && (
          <div style={{
            color: '#ef4444',
            backgroundColor: 'rgba(239, 68, 68, 0.1)',
            border: '1px solid rgba(239, 68, 68, 0.3)',
            padding: '0.75rem',
            marginBottom: '1rem',
            borderRadius: '0.375rem',
            textAlign: 'center',
          }}>
            {error}
          </div>
        )}

        {/* Success */}
        {message && (
          <div style={{
            color: '#34d399',
            backgroundColor: 'rgba(52, 211, 153, 0.1)',
            border: '1px solid rgba(52, 211, 153, 0.3)',
            padding: '0.75rem',
            marginBottom: '1rem',
            borderRadius: '0.375rem',
            textAlign: 'center',
          }}>
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column' }}>
          <label htmlFor="email" style={{ fontSize: '0.875rem', marginBottom: '0.5rem' }}>
            Email:
          </label>
          <input
            id="email"
            type="email"
            placeholder="youremail@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{
              padding: '0.75rem',
              background: '#334155',
              border: '1px solid #475569',
              color: 'white',
              borderRadius: '0.375rem',
              outline: 'none',
              marginBottom: '1rem',
              fontSize: '1rem',
              transition: 'border-color 0.2s',
            }}
            required
          />

          <button
            type="submit"
            disabled={isLoading}
            style={{
              padding: '0.75rem',
              background: '#3b82f6',
              color: 'white',
              border: 'none',
              borderRadius: '0.375rem',
              cursor: isLoading ? 'wait' : 'pointer',
              fontSize: '1rem',
              transition: 'background-color 0.2s',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              marginBottom: '1rem',
              opacity: isLoading ? 0.7 : 1
            }}
          >
            {isLoading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <div style={{ textAlign: 'center' }}>
          <a href="/login" style={{ color: '#94a3b8', textDecoration: 'none', fontSize: '0.875rem' }}>
            Back to Login
          </a>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
